import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useLazyGetCompletedTaskByLeadIdQuery } from "../../../features/taskSlice";
import Tooltip from "@mui/material/Tooltip";
import { colors } from "../../../Shared/colors";
import moment from "moment-timezone";
import AttachFileIcon from "@mui/icons-material/AttachFile";


const columns = [
  {
    field: "client",
    headerName: "Client",
    width: 160,
    flex: 1.2,
    renderCell: (params) => {
      return (
        <Tooltip
          title={
            <div
              style={{
                maxWidth: "200px",
                padding: "6px",
                fontSize: "0.75rem",
                lineHeight: "1.3",
                wordBreak: "break-word",
              }}
            >
              <strong>Client:</strong> {params.row.client}
            </div>
          }
          placement="top"
          arrow
          disablePortal={false}
          slotProps={{
            popper: {
              modifiers: [
                { name: "preventOverflow", options: { altBoundary: true, rootBoundary: "document" } },
              ],
              sx: { zIndex: 9999999 },
            },
          }}
        >
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              padding: "16px 12px",
              fontWeight: 600,
              color: "#1e293b",
              fontSize: "0.9rem",
              minHeight: 50,
            }}
          >
            {params.row.client}
          </div>
        </Tooltip>
      );
    },
  },
  {
    field: "cellNo",
    headerName: "Cell No",
    width: 140,
    flex: 1,
    renderCell: (params) => {
      return (
        <Tooltip
          title={
            <div
              style={{
                maxWidth: "200px",
                padding: "6px",
                fontSize: "0.75rem",
                lineHeight: "1.3",
                wordBreak: "break-word",
              }}
            >
              <strong>Phone Number:</strong> {params.row.cellNo}
            </div>
          }
          placement="top"
          arrow
          disablePortal={false}
          slotProps={{
            popper: {
              modifiers: [
                { name: "preventOverflow", options: { altBoundary: true, rootBoundary: "document" } },
              ],
              sx: { zIndex: 9999999 },
            },
          }}
        >
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              padding: "16px 12px",
              fontWeight: 500,
              color: "#475569",
              fontSize: "0.9rem",
              minHeight: 50,
            }}
          >
            {params.row.cellNo}
          </div>
        </Tooltip>
      );
    },
  },
  {
    field: "completedDate",
    headerName: "Date",
    width: 160,
    flex: 1.1,
    renderCell: (params) => {
      const date = moment(params.row.completedDate).tz("Asia/Karachi");
      const formattedDate = date.format("MMM D, YYYY");
      const formattedTime = date.format("h:mm A");
      const fullDate = date.format("dddd, MMMM D, YYYY [at] h:mm A");
      const isRecent = moment().diff(date, "days") <= 7;

      return (
        <Tooltip
          title={fullDate}
          placement="top"
          arrow
          disablePortal={false}
          slotProps={{
            popper: {
              modifiers: [
                { name: "preventOverflow", options: { altBoundary: true, rootBoundary: "document" } },
              ],
              sx: { zIndex: 9999999 },
            },
          }}
        >
          <div
            style={{
              padding: "12px",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              gap: "4px",
              minHeight: 50,
              position: "relative",
            }}
          >
            <div
              style={{
                fontSize: "0.9rem",
                fontWeight: 600,
                color: "#1e293b",
                lineHeight: 1.2,
              }}
            >
              {formattedDate}
            </div>
            <div
              style={{
                fontSize: "0.8rem",
                color: "#64748b",
                fontWeight: 500,
              }}
            >
              {formattedTime}
            </div>
            {isRecent && (
              <div
                style={{
                  position: "absolute",
                  top: "8px",
                  right: "8px",
                  width: "8px",
                  height: "8px",
                  borderRadius: "50%",
                  backgroundColor: "#10b981",
                  boxShadow: "0 0 0 2px rgba(16, 185, 129, 0.2)",
                }}
              />
            )}
          </div>
        </Tooltip>
      );
    },
  },
  // {
  //   field: "reason",
  //   headerName: "Reason",
  //   width: 140,
  //   flex: 1,
  //   renderCell: (params) => {
  //     const reason = params.row.reason || "No reason";
  //     const hasReason = params.row.reason && params.row.reason !== "No reason";

  //     return (
  //       <Tooltip
  //         title={
  //           <div
  //             style={{
  //               maxWidth: "250px",
  //               padding: "6px",
  //               fontSize: "0.75rem",
  //               lineHeight: "1.3",
  //               wordBreak: "break-word",
  //             }}
  //           >
  //             <strong>Reason:</strong> {reason}
  //           </div>
  //         }
  //         placement="top"
  //         arrow
  //         disablePortal={false}
  //         slotProps={{
  //           popper: {
  //             modifiers: [
  //               { name: "preventOverflow", options: { altBoundary: true, rootBoundary: "document" } },
  //             ],
  //             sx: { zIndex: 9999999 },
  //           },
  //         }}
  //       >
  //         <div
  //           style={{
  //             whiteSpace: "nowrap",
  //             overflow: "hidden",
  //             textOverflow: "ellipsis",
  //             padding: "16px 12px",
  //             fontWeight: hasReason ? 500 : 400,
  //             color: hasReason ? "#374151" : "#9ca3af",
  //             fontSize: "0.9rem",
  //             fontStyle: hasReason ? "normal" : "italic",
  //             minHeight: 50,
  //           }}
  //         >
  //           {reason}
  //         </div>
  //       </Tooltip>
  //     );
  //   },
  // },
  {
    field: "currentTaskType",
    headerName: "Task Type",
    width: 160,
    flex: 1.2,
    renderCell: (params) => {
      const currentTaskType = params.row.currentTaskType || "No currentTaskType";
      const isEmpty = currentTaskType === "No currentTaskType";

      return (
        <Tooltip
          title={
            <div
              style={{
                maxWidth: 220,
                padding: 6,
                fontSize: "0.8rem",
                lineHeight: 1.4,
                wordBreak: "break-word",
              }}
            >
              {currentTaskType}
            </div>
          }
          placement="top-start"
          arrow
          disablePortal={false}
          slotProps={{
            popper: {
              modifiers: [
                { name: "preventOverflow", options: { altBoundary: true, rootBoundary: "document" } },
                { name: "offset", options: { offset: [0, -10] } },
              ],
              sx: { zIndex: 9999999 },
            },
          }}
        >
          <div
            style={{
              width: "100%",
              padding: "8px 12px",
              fontSize: "0.9rem",
              lineHeight: 1.6,
              color: isEmpty ? "#64748b" : "#1f2937",
              whiteSpace: "normal",
              wordBreak: "break-word",
              display: "-webkit-box",
              WebkitLineClamp: 4,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              background: isEmpty ? "#f8fafc" : "transparent",
              border: isEmpty ? "1px solid #e5e7eb" : "none",
              borderRadius: 8,
              fontStyle: isEmpty ? "italic" : "normal",
              minHeight: 50,
              cursor: "help",
            }}
          >
            {currentTaskType}
          </div>
        </Tooltip>
      );
    },
  },
  {
    field: "currentSubTypeTask",
    headerName: "Sub Task Type",
    width: 160,
    flex: 1.2,
    renderCell: (params) => {
      const currentSubTypeTask = params.row.currentSubTypeTask || "No currentSubTypeTask";
      const isEmpty = currentSubTypeTask === "No currentSubTypeTask";

      return (
        <Tooltip
          title={
            <div
              style={{
                maxWidth: 220,
                padding: 6,
                fontSize: "0.8rem",
                lineHeight: 1.4,
                wordBreak: "break-word",
              }}
            >
              {currentSubTypeTask}
            </div>
          }
          placement="top-start"
          arrow
          disablePortal={false}
          slotProps={{
            popper: {
              modifiers: [
                { name: "preventOverflow", options: { altBoundary: true, rootBoundary: "document" } },
                { name: "offset", options: { offset: [0, -10] } },
              ],
              sx: { zIndex: 9999999 },
            },
          }}
        >
          <div
            style={{
              width: "100%",
              padding: "8px 12px",
              fontSize: "0.9rem",
              lineHeight: 1.6,
              color: isEmpty ? "#64748b" : "#1f2937",
              whiteSpace: "normal",
              wordBreak: "break-word",
              display: "-webkit-box",
              WebkitLineClamp: 4,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              background: isEmpty ? "#f8fafc" : "transparent",
              border: isEmpty ? "1px solid #e5e7eb" : "none",
              borderRadius: 8,
              fontStyle: isEmpty ? "italic" : "normal",
              minHeight: 50,
              cursor: "help",
            }}
          >
            {currentSubTypeTask}
          </div>
        </Tooltip>
      );
    },
  },
  {
    field: "comment",
    headerName: "Comment",
    width: 200,
    flex: 1.5,
    renderCell: (params) => {
      const comment = params.row.comment || "No comment";
      const isEmpty = comment === "No comment";

      return (
        <Tooltip
          title={
            <div
              style={{
                maxWidth: 420,
                padding: 6,
                fontSize: "0.8rem",
                lineHeight: 1.4,
                wordBreak: "break-word",
              }}
            >
              {comment}
            </div>
          }
          placement="top-start"
          arrow
          disablePortal={false}
          slotProps={{
            popper: {
              modifiers: [
                { name: "preventOverflow", options: { altBoundary: true, rootBoundary: "document" } },
                { name: "offset", options: { offset: [0, -10] } },
              ],
              sx: { zIndex: 9999999 },
            },
          }}
        >
          <div
            style={{
              width: "100%",
              padding: "8px 12px",
              fontSize: "0.9rem",
              lineHeight: 1.6,
              color: isEmpty ? "#64748b" : "#1f2937",
              whiteSpace: "normal",
              wordBreak: "break-word",
              display: "-webkit-box",
              WebkitLineClamp: 4, // show fewer lines for more compact display
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              background: isEmpty ? "#f8fafc" : "transparent",
              border: isEmpty ? "1px solid #e5e7eb" : "none",
              borderRadius: 8,
              fontStyle: isEmpty ? "italic" : "normal",
              minHeight: 50,
              cursor: "help", // Indicate tooltip is available
            }}
          >
            {comment}
          </div>
        </Tooltip>
      );
    },
  },
  {
    field: "attachment",
    headerName: "Attachment",
    width: 120,
    flex: 1,
    renderCell: (params) => {
      return (
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "16px 12px",
            minHeight: 50,
          }}
        >
          {params.row.attachment ? (
            <Tooltip
              title="Click to view attachment"
              placement="top"
              arrow
              disablePortal={false}
              slotProps={{
                popper: {
                  modifiers: [
                    { name: "preventOverflow", options: { altBoundary: true, rootBoundary: "document" } },
                  ],
                  sx: { zIndex: 9999999 },
                },
              }}
            >
              <a
                href={params.row.attachment}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  padding: "8px 12px",
                  backgroundColor: colors.brown,
                  color: "white",
                  textDecoration: "none",
                  borderRadius: "8px",
                  fontSize: "0.8rem",
                  fontWeight: 600,
                  transition: "all 0.2s ease",
                  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#1a6b6b";
                  e.target.style.transform = "translateY(-1px)";
                  e.target.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.15)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = colors.brown;
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.1)";
                }}
              >
                <AttachFileIcon style={{ fontSize: "16px" }} />
                View
              </a>
            </Tooltip>
          ) : (
            <Tooltip
              title="No attachment available"
              placement="top"
              arrow
              disablePortal={false}
              slotProps={{
                popper: {
                  modifiers: [
                    { name: "preventOverflow", options: { altBoundary: true, rootBoundary: "document" } },
                  ],
                  sx: { zIndex: 9999999 },
                },
              }}
            >
              <div
                style={{
                  color: "#9ca3af",
                  fontSize: "0.8rem",
                  fontStyle: "italic",
                  padding: "8px 12px",
                }}
              >
                No file
              </div>
            </Tooltip>
          )}
        </div>
      );
    },
  },
  {
    field: "empName",
    headerName: "Employee",
    width: 160,
    flex: 1.2,
    renderCell: (params) => {
      const empName = params.row.empName || "Unknown";


      return (
        <Tooltip
          title={
            <div
              style={{
                maxWidth: "200px",
                padding: "6px",
                fontSize: "0.75rem",
                lineHeight: "1.3",
                wordBreak: "break-word",
              }}
            >
              <strong>Employee:</strong> {empName}
            </div>
          }
          placement="top"
          arrow
          disablePortal={false}
          slotProps={{
            popper: {
              modifiers: [
                { name: "preventOverflow", options: { altBoundary: true, rootBoundary: "document" } },
              ],
              sx: { zIndex: 9999999 },
            },
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              padding: "12px",
              minHeight: 50,
            }}
          >
            <div
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "50%",

                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "0.8rem",
                fontWeight: 700,
              }}
            >
            </div>
            <span
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontSize: "0.9rem",
                fontWeight: 600,
                color: "#1e293b",
              }}
            >
              {empName}
            </span>
          </div>
        </Tooltip>
      );
    },
  },
];

export const TaskTable = ({ leadId }) => {
  const [getCompletedTaskByLeadId, { data: taskData, isFetching }] = useLazyGetCompletedTaskByLeadIdQuery();
  const [pageSize, setPageSize] = useState(5);

  useEffect(() => {
    if (leadId) {
      getCompletedTaskByLeadId(leadId);
    }
  }, [leadId, getCompletedTaskByLeadId]);

  let rows = [];
  if (taskData && taskData.length > 0) {
    taskData.forEach((leadData) => {
      // Extract client info from the lead data
      const clientName = leadData?.client?.fullName || "Unknown";
      const clientPhone = leadData?.client?.cellNo?.[0]?.phoneNo || "N/A";

      // Process each task in the currentTask array
      if (leadData?.currentTask && Array.isArray(leadData.currentTask)) {
        leadData.currentTask.forEach((task, index) => {
          rows.push({
            id: `${leadData._id}_${task._id || index}`, // Unique ID for each task
            client: clientName,
            cellNo: clientPhone,
            currentTaskType: task?.currentTaskType,
            currentSubTypeTask: task?.currentSubTypeTask,
            completedDate: new Date(task?.completedDate),
            reason: task?.reason,
            comment: task?.comment,
            attachment: task?.attachment,
            empName: task?.empName,
          });
        });
      }
    });
  }

  return (
    // ✅ Centered table in modal
    <div style={{
      height: "100%",
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "20px"
    }}>
      <style>
        {`
          /* Global fix for pagination dropdown z-index */
          .MuiMenu-root {
            z-index: 9999999 !important;
          }
          .MuiMenu-paper {
            z-index: 9999999 !important;
          }
          .MuiPopover-root {
            z-index: 9999999 !important;
          }
          .MuiPopover-paper {
            z-index: 9999999 !important;
          }
          .MuiSelect-menu {
            z-index: 9999999 !important;
          }
          .MuiMenuItem-root {
            z-index: 9999999 !important;
          }
          .MuiTablePagination-select .MuiSelect-select {
            z-index: 9999999 !important;
          }
          .MuiTablePagination-select .MuiSelect-icon {
            z-index: 9999999 !important;
          }
        `}
      </style>
      <div style={{
        width: "100%",
        maxWidth: "1200px",
        height: "100%",
        minHeight: "400px",
        maxHeight: "80vh",
        overflow: "hidden"
      }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={pageSize}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          rowsPerPageOptions={[5, 10, 20]}
          checkboxSelection
          disableSelectionOnClick
          experimentalFeatures={{ newEditingApi: true }}
          loading={isFetching}
          pagination
          paginationMode="client"
          // ❗ Remove autoHeight so it respects container height
          // autoHeight
          rowHeight={72} // Reduced row height for more compact table
          sx={{
            border: "none",
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)",
            background: "#ffffff",
            "& .MuiDataGrid-root": {
              border: "none",
              fontFamily:
                'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "1px solid #f1f5f9",
              padding: 0,
              fontSize: "0.875rem",
              color: "#334155",
              "&:focus, &:focus-within": { outline: "none" },
              minHeight: "50px", // Reduced from 60px
            },
            "& .MuiDataGrid-columnHeaders": {
              background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
              borderBottom: "2px solid #e2e8f0",
              fontWeight: 700,
              fontSize: "0.9rem",
              color: "#1e293b",
              minHeight: "56px !important",
              "& .MuiDataGrid-columnHeaderTitle": {
                fontWeight: 700,
                letterSpacing: "0.025em",
              },
              "& .MuiDataGrid-columnHeaderTitleContainer": {
                justifyContent: "center",
              },
            },
            "& .MuiDataGrid-row": {
              minHeight: "72px !important", // Matched rowHeight
              "&:nth-of-type(even)": {
                backgroundColor: "#fafbfc",
              },
              "&:hover": {
                backgroundColor: "#f0f9ff !important",
                transform: "translateY(-1px)",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                transition: "all 0.2s ease",
              },
              "&.Mui-selected": {
                backgroundColor: "#eff6ff !important",
                "&:hover": {
                  backgroundColor: "#dbeafe !important",
                },
              },
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "2px solid #e2e8f0",
              backgroundColor: "#f8fafc",
              minHeight: "64px",
              padding: "0 24px",
            },
            "& .MuiTablePagination-root": {
              color: "#64748b",
              fontSize: "0.875rem",
              fontWeight: 500,
            },
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
              fontSize: "0.875rem",
              fontWeight: 600,
              color: "#475569",
            },
            "& .MuiTablePagination-select": {
              fontSize: "0.875rem",
              fontWeight: 600,
              borderRadius: "8px",
              border: "1px solid #d1d5db",
              padding: "4px 8px",
              zIndex: "9999999 !important",
              "&:hover": {
                borderColor: colors.brown,
              },
            },
            "& .MuiTablePagination-actions .MuiIconButton-root": {
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "#f1f5f9",
              },
            },
            // Fix all tooltip z-index issues
            "& .MuiTooltip-popper": {
              zIndex: "9999999 !important",
            },
            "& .MuiDataGrid-toolbarContainer .MuiTooltip-popper": {
              zIndex: "9999999 !important",
            },
            "& .MuiTablePagination-toolbar .MuiTooltip-popper": {
              zIndex: "9999999 !important",
            },
            "& .MuiDataGrid-columnHeader .MuiTooltip-popper": {
              zIndex: "9999999 !important",
            },
            "& .MuiDataGrid-cell .MuiTooltip-popper": {
              zIndex: "9999999 !important",
            },
            // Fix pagination dropdown z-index
            "& .MuiTablePagination-select .MuiSelect-select": {
              zIndex: "9999999 !important",
            },
            "& .MuiTablePagination-select .MuiSelect-icon": {
              zIndex: "9999999 !important",
            },
            "& .MuiTablePagination-select .MuiMenu-root": {
              zIndex: "9999999 !important",
            },
            "& .MuiTablePagination-select .MuiMenu-paper": {
              zIndex: "9999999 !important",
            },
            // Additional dropdown menu fixes
            "& .MuiMenu-root": {
              zIndex: "9999999 !important",
            },
            "& .MuiMenu-paper": {
              zIndex: "9999999 !important",
            },
            "& .MuiPopover-root": {
              zIndex: "9999999 !important",
            },
            "& .MuiPopover-paper": {
              zIndex: "9999999 !important",
            },
            // Global dropdown menu fixes
            "& .MuiSelect-menu": {
              zIndex: "9999999 !important",
            },
            "& .MuiMenuItem-root": {
              zIndex: "9999999 !important",
            },
            "& .MuiDataGrid-checkboxInput, & .MuiDataGrid-columnHeaderCheckbox": {
              color: colors.brown,
              "&.Mui-checked": { color: colors.brown },
            },
            // Important: allow poppers to escape scroller if needed
            "& .MuiDataGrid-main": {
              overflow: "auto",
              maxHeight: "calc(80vh - 120px)" // Account for header and footer
            },
            "& .MuiDataGrid-virtualScroller": {
              overflow: "auto",
              "&::-webkit-scrollbar": { width: "8px", height: "8px" },
              "&::-webkit-scrollbar-track": {
                background: "#f1f5f9",
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "#cbd5e1",
                borderRadius: "4px",
                "&:hover": { background: "#94a3b8" },
              },
            },
          }}
          disableColumnMenu
          disableColumnFilter
          disableColumnSelector
        />
      </div>
    </div>
  );
};
